<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import Snackbar from "@/components/Snackbar.vue";
import LoadingOverlay from "./components/LoadingOverlay.vue";
import StopAll from "./components/StopAll.vue";
import HeaderComponent from "./components/partials/HeaderComponent.vue";
import FormHeaderComponent from "./components/partials/FormHeaderComponent.vue";
import FooterComponent from "./components/partials/FooterComponent.vue";
import PublicHeader from "./components/partials/PublicHeader.vue";
import PublicFooter from "./components/partials/PublicFooter.vue";
import { useAuthStore } from "@/stores";
import { computed } from "vue";
import "@/assets/home-v2.css";

const route = useRoute();
const authStore = useAuthStore();

// Site v2 (Figma "Site Desktop"): navbar e rodapé novos nas páginas
// institucionais. A área logada continua no header antigo, que é o único
// que conhece plano, créditos, menus de admin e troca de idioma.
const publicSiteRoutes = [
  "/",
  "/sobre-nos",
  "/planos",
  "/contato",
  "/login",
  "/register",
  "/recover",
];

const isPublicSite = computed(
  () => publicSiteRoutes.includes(route.path) && !authStore.isAuth
);
// const isHome = computed(() => route.path === '/' || '/register');
const hiddenRoutes = ['/', '/contato', '/planos', '/sobre-nos', '/login', '/register', '/recover'];

const isHome = computed(() => hiddenRoutes.includes(route.path));
const isSandbox = import.meta.env.VITE_APP_MODE != 'production';
const shouldHideBackgroundCircles = computed(() => {
  const routeName = route.name as string;
  return routeName?.startsWith('formdata_source_') || routeName?.startsWith('separate_page') || routeName?.startsWith('form_source');
});

function isContactSubdomain() {
  return typeof window !== 'undefined' && 
         (window.location.hostname === 'cadastro.selfiecheckin.com.br' || 
          window.location.hostname === 'cadastro.selfiecheckin.com' || 
          window.location.hostname === 'cadastro.localhost');
}

</script>

<template>
  <!-- <v-alert :prominent="true" type="info" v-if="isSandbox">
    Você está no ambiente de testes. As ações aqui geradas não surtem efeito real, com exceção das fechaduras TTLock.
  </v-alert> -->
  <div v-if="!isHome && shouldHideBackgroundCircles" class="form-background"></div>
  <v-app style="overflow: hidden;">
    <div v-if="!isHome && !shouldHideBackgroundCircles" class="background-circle circle-1"></div>
    <div v-if="!isHome && !shouldHideBackgroundCircles" class="background-circle circle-2"></div>
    <component
      v-if="!(route.name as string)?.startsWith('separate_page') && !isContactSubdomain()"
      :is="
        isPublicSite
          ? PublicHeader
          : (route.name as string)?.startsWith('formdata_source_')
            ? FormHeaderComponent
            : HeaderComponent
      "
    />
    <RouterView />
    <Snackbar />
  </v-app>
  <LoadingOverlay />
  <StopAll />
  <PublicFooter v-if="isPublicSite" />
  <FooterComponent v-else />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap" rel="stylesheet');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');

h1,
h2,
h3 {
  font-family: 'Viga', sans-serif;
  color: #151F45;
}

body {
  scroll-behavior: smooth;
  font-family: 'Roboto', sans-serif;
  color: #151F45;
}

section {
  width: 100%;
}

.v-navigation-drawer__content {
  width: 100%;
}

.mobile-nav-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }
}

.background-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.3;
  animation: pulse 3s infinite;
}

.circle-1 {
  width: 30rem;
  /* Tamanho do círculo */
  height: 30rem;
  /* Tamanho do círculo */
  background: #1AD079;
  filter: blur(8rem);
  top: 15%;
  /* Ajuste de posição */
  right: 3%;
  /* Ajuste de posição */
}

@media (min-width: 960px) {
  .form-background {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #F6F6F6;
    z-index: 0;
  }

  .v-app {
    position: relative;
    z-index: 1;
  }
}

@media (max-width: 959px) {
.form-background {
    display: none;
  }
}

.circle-2 {
  width: 30rem;
  /* Tamanho do círculo */
  height: 30rem;
  /* Tamanho do círculo */
  background: #26387E;
  filter: blur(8rem);
  /* Borrado */
  bottom: 0%;
  /* Ajuste de posição */
  left: 8%;
  /* Ajuste de posição */
}
</style>
